<template>
  <div class="orderlist_container">订单列表</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
 .orderlist_container {
   width: 100%;
   height: 100%;
 }
</style>